module.exports = __webpack_public_path__ + "static/media/sucess.2cf96a80.svg";